import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Clock, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // 監聽滾動事件，改變導航欄樣式
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 導航連結
  const navLinks = [
    { text: '首頁', path: '/' },
    { text: '功能特色', path: '/features' },
    { text: '方案價格', path: '/pricing' },
    { text: '聯繫我們', path: '/contact' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
        }`}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <Clock className="text-primary-600" size={32} />
            <span className="ml-2 text-xl font-bold text-gray-900">智能出勤系統</span>
          </Link>

          {/* 行動版選單按鈕 */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2 lg:hidden"
            aria-label="開啟選單"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* 桌面版選單 */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`text-base font-medium hover:text-primary-600 transition-colors ${location.pathname === link.path ? 'text-primary-600 font-semibold' : 'text-gray-700'
                  }`}
              >
                {link.text}
              </Link>
            ))}
            <Link
              to="/contact"
              className="btn btn-primary"
            >
              免費試用
            </Link>
          </nav>
        </div>

        {/* 行動版選單展開 */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white py-4 mt-2 rounded-lg shadow-lg border border-gray-100">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`block px-4 py-3 text-base font-medium hover:bg-gray-50 ${location.pathname === link.path ? 'text-primary-600' : 'text-gray-700'
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.text}
              </Link>
            ))}
            <div className="px-4 pt-2 pb-4">
              <Link
                to="/contact"
                className="btn btn-primary w-full"
                onClick={() => setIsMenuOpen(false)}
              >
                免費試用
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;